import InventaireStockFormController from './inventaire.stock.form.controller';
import Template from './inventaire.stock.form.html';

export default {
	template: Template,
	controller: InventaireStockFormController
};
